import React, { useState } from 'react';
import { Mail, Phone, Send, CheckCircle, AlertCircle } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      // Using SMTP.js for sending email
      // Note: User needs to configure their Gmail SMTP credentials
      const emailBody = `
        Ime: ${formData.name}
        Email: ${formData.email}
        Telefon: ${formData.phone}
        Predmet: ${formData.subject}
        
        Poruka:
        ${formData.message}
      `;

      // Check if Email object is available (SMTP.js loaded)
      if (window.Email) {
        await window.Email.send({
          SecureToken: process.env.REACT_APP_EMAIL_TOKEN || "YOUR_SECURE_TOKEN_HERE",
          To: 'luka.postruzin9@gmail.com',
          From: process.env.REACT_APP_EMAIL_FROM || 'luka.postruzin9@gmail.com',
          Subject: `Nova poruka od ${formData.name}: ${formData.subject}`,
          Body: emailBody
        });

        setStatus({
          type: 'success',
          message: 'Poruka je uspješno poslana! Javit ćemo vam se uskoro.'
        });
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      } else {
        // Fallback message if SMTP.js is not loaded
        setStatus({
          type: 'info',
          message: 'Konfigurirajte email postavke za slanje poruka. Kontaktirajte nas direktno na luka.postruzin9@gmail.com ili +385913653328'
        });
      }
    } catch (error) {
      setStatus({
        type: 'error',
        message: 'Došlo je do greške. Molimo pokušajte ponovo ili nas kontaktirajte direktno.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="section-header">
          <span className="section-badge">Kontakt</span>
          <h2 className="section-title">Javite se s povjerenjem</h2>
          <p className="section-description">
            Imate pitanja ili želite rezervirati uslugu? Javite se.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <h3 className="contact-info-title">Kontakt info</h3>
            <p className="contact-info-text">
              Odgovaramo na sve upite u roku od 24 sata. Odaberite način komunikacije koji vam najbolje odgovara.
            </p>

            <div className="contact-methods">
              <div className="contact-method">
                <div className="method-icon">
                  <Mail size={24} />
                </div>
                <div className="method-content">
                  <div className="method-label">Email</div>
                  <a href="mailto:luka.postruzin9@gmail.com" className="method-value">
                    luka.postruzin9@gmail.com
                  </a>
                </div>
              </div>

              <div className="contact-method">
                <div className="method-icon">
                  <Phone size={24} />
                </div>
                <div className="method-content">
                  <div className="method-label">Telefon</div>
                  <a href="tel:+385913653328" className="method-value">
                    +385 91 365 3328
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-hours">
              <h4>Radno Vrijeme</h4>
              <p>Po dogovoru</p>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Ime i Prezime *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Vaše ime"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="vas.email@example.com"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Telefon</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+385 ..."
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Predmet *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="Upit o usluzi"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="message">Poruka *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="6"
                placeholder="Opišite vaš upit..."
              ></textarea>
            </div>

            {status.message && (
              <div className={`form-status ${status.type}`}>
                {status.type === 'success' && <CheckCircle size={20} />}
                {status.type === 'error' && <AlertCircle size={20} />}
                {status.type === 'info' && <AlertCircle size={20} />}
                <span>{status.message}</span>
              </div>
            )}

            <button type="submit" className="submit-button" disabled={isSubmitting}>
              {isSubmitting ? 'Slanje...' : 'Pošalji poruku'}
              <Send size={20} />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
